module.exports = __webpack_public_path__ + "img/down_icon.0a94ec7f.svg";